import layout from './MessageBoxView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';

export default class MessageBoxView extends View {
    private view: JQuery<HTMLElement>;

    public constructor(private viewModel: any, private element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('MessageBoxView', MessageBoxView, 'RADPresentation.HTMLClient.DefaultViewExtensions');